import { Component, Input, OnInit } from '@angular/core';
import { IFilterFilters } from '../ifilter';
import { Datalistrequestfilter } from '../../request/datalistrequestfilter';

@Component({
    selector: '[app-single-date-filter]',
    templateUrl: './single-date-filter.component.html',
    styleUrls: ['./single-date-filter.component.scss'],
    host: { 'class': 'control' },
    standalone: false
})
export class SingleDateFilterComponent implements OnInit, IFilterFilters {

  @Input()
  public DateSearchProperty: string = "IssuedDate";

  @Input()
  public Placeholder: string = "Filter by date...";

  public FilterName: string = "singledate";
  public Filters: Datalistrequestfilter[] = [];
  public QueryParamPrefix: string = '';
  public selectedDate: string = "";

  constructor() { }

  ngOnInit(): void {
  }

  public onDateChange(event: any) {
    const dateValue = event.target.value;
    this.Filters = [];

    if (dateValue && dateValue !== "") {
      // Create filters for start and end of the selected day
      const [year, month, day] = dateValue.split("-").map(Number);
      const startOfDay = new Date(year, month - 1, day, 0, 0, 0, 0);
      const endOfDay = new Date(year, month - 1, day, 23, 59, 59, 999);

      this.Filters.push({
        Property: this.DateSearchProperty,
        Comparator: ">=",
        Value: startOfDay.toISOString() + "local",
        FilterName: this.FilterName
      });

      this.Filters.push({
        Property: this.DateSearchProperty,
        Comparator: "<=",
        Value: endOfDay.toISOString() + "local",
        FilterName: this.FilterName
      });

      this.selectedDate = dateValue;
    } else {
      this.selectedDate = "";
    }
  }

  public clearDate() {
    this.selectedDate = "";
    this.Filters = [];
  }
}

